export default "__VITE_ASSET__Gy$7e2nN__"